import React from 'react'
import { Link } from 'react-router-dom'
import { Table, Space, Button } from 'antd'
import { EditOutlined } from '@ant-design/icons'
import { ListComponent, BaseListComponentProps } from '../BaseComponent'
import { SearchRequest } from '../../services/api/interfaces/ApiRequest'
import { Pagination } from 'components/Pagination'

type QuestionListProps = BaseListComponentProps & {
  loading: boolean,
  questions: any,
  pagination: any,
  editing?: any,
  defaultSubmitOptions: any,
  loadQuestions: (args: SearchRequest) => void
}

export default class QuestionList extends ListComponent<QuestionListProps> {

  static defaultProps = {
    loading: false,
    question: [],

    loadQuestions: () => { }
  }

  tableColumns = [
    {
      title: 'Group',
      dataIndex: ['group', 'name'],
      key: 'group',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.group.name - b.group.name
    },
    {
      title: 'UUID',
      dataIndex: 'uuid',
      key: 'uuid',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.uuid - b.uuid
    },
    {
      title: 'Ask',
      dataIndex: 'ask',
      key: 'ask',
      sorter: (a: any, b: any) => a.ask.length - b.ask.length
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.position - b.position
    },
    {
      title: 'Type',
      dataIndex: 'form_tag_key',
      key: 'form_tag_key',
      responsive: ['md'] as any,
      sorter: (a: any, b: any) => a.form_tag_key.length - b.form_tag_key.length
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text: string, record: any) => (
        <Space size='middle'>
          <Link to={`question/${record.uuid}`} ref={(refs) => this.actionRefs.edit.push(refs)}>
            <Button type="dashed" shape="round" icon={<EditOutlined />} />
          </Link>
        </Space>
      )
    }
  ]

  protected load() {
    this.searchOptions.search =  {
      group: {
        with: true
      },
      specie: {
        with: true
      }
    }

    this.props.loadQuestions(this.searchOptions)
  }


  render() {
    const { loading, pagination, questions, loadQuestions, defaultSubmitOptions } = this.props

    return (
      <>
        <Table
          loading={loading}
          rowKey='uuid'
          columns={this.tableColumns}
          pagination={false}
          dataSource={questions}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, (args) =>
              loadQuestions({
                options: {
                   sort: args.options.sort.length > 0
                    ? args.options.sort
                    : defaultSubmitOptions.options.sort
                },
                search: { ...defaultSubmitOptions.search }
              }))}
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={questions?.length}
          onChange={(pagination) =>
            this.handleTableChange(
              pagination,
              undefined,
              (args) => {
                console.log(args)
                loadQuestions({
                  options: {
                    ...args.options, sort: args.options.sort.length > 0
                      ? args.options.sort
                      : defaultSubmitOptions.options.sort
                  },
                  search: { ...defaultSubmitOptions.search }
                })
              }
            )
          }
        />
      </>
    )
  }
}
